import { Component, Input } from '@angular/core';
import { ClosetDoorsStandardStep } from '../models/closet-doors-standard-step.enum';

/**
 * Orchestrateur de la preview du configurateur portes standard.
 * Délègue l'affichage à un sous-composant dédié selon l'étape courante.
 */
@Component({
  selector: 'ng-closet-doors-standard-preview',
  templateUrl: './preview.component.html',
  styleUrls: ['./preview.component.scss'],
})
export class ClosetDoorsStandardPreviewComponent {
  readonly Step = ClosetDoorsStandardStep;

  /** Étape courante du configurateur. */
  @Input() step: number;

  /** Sous-étape active au sein de l'étape Finitions (Structure / Décors / Profilé). */
  @Input() finishesStep: number;

  /** Indique que l'étape Finitions a terminé son rendu initial — déclenche le focus sur le premier vantail. */
  @Input() finishesRendered: boolean = false;
}
